export const COUPON_CODE_QUERY_PARAM = 'coupon_code';
export const COUPON_CODE_FROM_LINK_SESSION_STORAGE_KEY =
  'coupon_code_from_link';
